/**
 * Sub-ministry grid used on the Listen Live and Father's House Church pages.
 * Accepts an array of { Icon, title, body, image? } objects. When an image is
 * provided it is rendered as a full-bleed background with a dark overlay so
 * the icon + copy stay readable.
 */
export default function MinistryGrid({
  items,
  heading,
  subheading,
  testId = "ministry-grid",
}) {
  return (
    <section data-testid={testId} className="border-t border-white/5">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-20 lg:py-24">
        {(heading || subheading) && (
          <div className="mb-10 flex flex-col lg:flex-row lg:items-end justify-between gap-6">
            <div>
              <span className="text-[11px] uppercase tracking-[0.3em] text-[#C5D1EB]/70">
                Ministries
              </span>
              {heading && (
                <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl text-white mt-3 tracking-tight max-w-2xl leading-[1.05]">
                  {heading}
                </h2>
              )}
            </div>
            {subheading && (
              <p className="text-[#C5D1EB] text-sm sm:text-base max-w-md leading-relaxed">
                {subheading}
              </p>
            )}
          </div>
        )}

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
          {items.map(({ Icon, title, body, image }, i) => (
            <article
              key={title}
              data-testid={`${testId}-card-${i}`}
              className="group relative overflow-hidden bg-white/[0.03] backdrop-blur-md border border-white/10 hover:border-[#C5001A]/60 p-6 sm:p-7 flex flex-col min-h-[260px] hover:-translate-y-1 transition-all duration-300"
            >
              {image && (
                <>
                  <div
                    aria-hidden
                    className="absolute inset-0 bg-cover bg-center scale-105 group-hover:scale-110 transition-transform duration-[1500ms]"
                    style={{ backgroundImage: `url(${image})` }}
                  />
                  <div
                    aria-hidden
                    className="absolute inset-0"
                    style={{
                      background:
                        "linear-gradient(180deg, rgba(11,12,16,0.55) 0%, rgba(11,12,16,0.82) 60%, rgba(11,12,16,0.95) 100%)",
                    }}
                  />
                </>
              )}
              <div className="relative flex flex-col h-full">
                <span className="inline-flex w-11 h-11 items-center justify-center bg-[#C5001A]/15 border border-[#C5001A]/60 text-[#C5001A] group-hover:bg-[#C5001A] group-hover:text-white transition-colors">
                  <Icon size={18} />
                </span>
                <h3 className="mt-5 font-display text-lg text-white tracking-tight leading-tight">
                  {title}
                </h3>
                <p className="mt-2 text-sm text-[#C5D1EB] leading-relaxed">
                  {body}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
